
document.addEventListener('DOMContentLoaded',function(){  
document.querySelectorAll('.accordianjshandle').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            target.target.closest('.custom-faqs-Items').classList.toggle('active');
        });
    });  
});